// src/pages/SuperAdmin/BusinessRoleProfiles.tsx
// Redirection vers la page détails du business avec l'onglet "Profils de rôle" actif

import React, { useEffect } from 'react';
import { useParams, useNavigate } from 'react-router-dom';

const BusinessRoleProfiles: React.FC = () => {
  const { businessId } = useParams<{ businessId: string }>();
  const navigate = useNavigate();

  useEffect(() => {
    if (businessId) {
      navigate(`/super-admin/businesses/${businessId}?tab=roles`, { replace: true });
    } else {
      navigate('/super-admin/businesses', { replace: true });
    }
  }, [businessId, navigate]);

  return null;
};

export default BusinessRoleProfiles;

